export default __webpack_public_path__ + "static/media/t-pay.1a8d079a.svg";